import React from "react";
import { Tooltip, Icon } from "antd";

export const Tip = ({ children }) => (
    <Tooltip title={children}>
        <Icon type="question-circle" />
    </Tooltip>
);

export default Tip;